const ACCESS_KEY = "fe_access_token";
const REFRESH_KEY = "fe_refresh_token";

export function getStoredAccessToken() {
  return window.localStorage.getItem(ACCESS_KEY) || "";
}

export function getStoredRefreshToken() {
  return window.localStorage.getItem(REFRESH_KEY) || "";
}

export function setStoredTokens(accessToken, refreshToken) {
  if (accessToken) {
    window.localStorage.setItem(ACCESS_KEY, accessToken);
  }
  if (refreshToken) {
    window.localStorage.setItem(REFRESH_KEY, refreshToken);
  }
}

export function clearStoredTokens() {
  window.localStorage.removeItem(ACCESS_KEY);
  window.localStorage.removeItem(REFRESH_KEY);
}
